import React, { useState, useEffect } from "react";
import Masters_header from './Masters_header';
import "../../styles/User.css";
import Vector from "../../assets/svg/editIcon.svg";
import Delete from "../../assets/svg/DeleteIcon.svg";
import { ToastContainer, toast } from "react-toastify";
import ReactPaginate from "react-paginate";
import down_arrow from "../../assets/svg/down_arrow.svg";
import { useNavigate } from 'react-router-dom';
import axiosInstance from "../../axiosInstance";
import { usePermissions } from "../../hooks/PermissionContext";
import PermissionWrapper from "../../hooks/PermissionWrapper";
import ConfirmDialog from "../../ConfirmDialog/ConfirmDialog";
import CommonFooter from "../../CommonFooter/CommonFooter";

const User = () => {

  let ModuleId = 4
  const { getModulePermission } = usePermissions();
  const permission = getModulePermission(ModuleId);
  console.log("activeModuleId", ModuleId);
  const [searchTerm, setSearchTerm] = useState('');
  const [tableData, setTableData] = useState([]);
  const [limit, setLimit] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const navigate = useNavigate();
  const [skip, setSkip] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const isAllSelected = selectedRows.length === tableData.length;
  const isAnySelected = selectedRows.length > 0;

  useEffect(() => {
    fetchUsers(searchTerm);
  }, [skip, limit]);

  const fetchUsers = async (term = '') => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.get('/user/list', {
        params: {
          search: term || undefined,
          limit,
          skip,
        },
      });

      if (response.data && Array.isArray(response.data.users)) {
        const users = response.data.users;
        const totalRec = response.data.total_rec || 0;
        const totalPagesCalc = Math.ceil(totalRec / limit);

        setTableData(users);
        setTotalCount(totalRec);
        setTotal(totalRec);
        setTotalPages(totalPagesCalc);

        console.log("Users:", users);
        console.log("Total pages:", totalPagesCalc);
      }
    } catch (error) {
      toast.error("Failed to fetch users");
      console.error("Error fetching users:", error);
    } finally {
      setIsLoading(false);
    }
  };



  const handleAddNewClick = () => {
    navigate("/userCreation");
  };

  const handleSelectAll = () => {
    if (tableData.length === 0) return;
    setSelectedRows(isAllSelected ? [] : tableData.map((row) => row.id));
  };

  const handleRowSelect = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handlePageClick = ({ selected }) => {
    const newSkip = selected * limit;
    setCurrentPage(selected);
    setSkip(newSkip);
    setSelectedRows([]);
  };

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);
    setLimit(newLimit);
    setCurrentPage(0);
    setSkip(0);
  };

  const handleDeleteUser = (userId) => {
    setDeleteId(userId);
    setConfirmOpen(true);
  };

  const confirmDelete = async () => {
    if (!deleteId) return
    {
      try {
        await axiosInstance.delete(`/user/delete/${deleteId}`);
        toast.success("User deleted successfully");
        fetchUsers(); // Refresh the list
      } catch (error) {
        toast.error("Failed to delete user");
        console.error("Error deleting user:", error);
      } finally {
        setConfirmOpen(false);
        setDeleteId(null);
      }
    }
  };

  const cancelDelete = () => {
    setConfirmOpen(false);
    setDeleteId(null);
  };

  const handleEditClick = async (userId) => {
    try {
      const response = await axiosInstance.get(`/user/edit/${userId}`);
      // Navigate to user creation page with edit data
      navigate('/userCreation', { state: { editData: response.data.user, userId } });
    } catch (error) {
      toast.error("Failed to fetch user details");
      console.error("Error fetching user:", error);
    }
  };

  const handleSearch = async (term) => {
    setSearchTerm(term);
    setSkip(0);
    await fetchUsers(term);
  };


  return (
    <>
      <Masters_header onSearch={handleSearch} />
      <div className="container">
        <div className="header d-flex justify-content-between">
          <h3>User: {totalCount}</h3>

          <PermissionWrapper permissionKey="create_permission" moduleId={ModuleId}>
            {/* {!isAnySelected && ( */}
            <button id="addNewBtn" onClick={handleAddNewClick}>Add New</button>
            {/* )} */}
          </PermissionWrapper>

        </div>

        <div className="user-table" style={{ overflowX: 'auto', scrollBehavior: 'smooth' }}>
          <table>
            <thead>
              <tr>
                {/* <th>
                      <input
                        type="checkbox"
                        checked={isAllSelected}
                        onChange={handleSelectAll}
                        disabled={tableData.length === 0}
                      />
                    </th> */}
                <th>S.No</th>
                {/* <th>Code</th> */}
                <th>Name</th>
                {/* <th>First Name</th>
                    <th>Last Name</th> */}
                <th>Employee ID</th>
                <th>Designation</th>
                <th>Email</th>
                <th>Mobile Number</th>
                {/* <th>City</th>
                    <th>State</th>
                    <th>Country</th>
                    <th>ZIP Code</th> */}
                <th></th>
              </tr>
            </thead>
            <tbody>
              {tableData.length > 0 ? (
                  tableData.map((row, index) => (
                    <tr key={row.id}>
                      {/* <td>
                        <input
                          type="checkbox"
                          checked={selectedRows.includes(row.id)}
                          onChange={() => handleRowSelect(row.id)}
                        />
                      </td> */}
                  <td>{currentPage * limit + index + 1}</td>
                  {/* <td>{row.code}</td> */}
                  <td>{row.name || `${row.firstName} ${row.lastName}`}</td>
                  {/* <td>{row.first_name}</td>
                      <td>{row.last_name}</td> */}
                  <td>{row.employee_id}</td>
                  <td>{row.designation}</td>
                  <td>{row.email}</td>
                  <td>{row.contact_number}</td>
                  {/* <td>{row.city_id}</td>
                      <td>{row.state_id}</td>
                      <td>{row.country_id}</td>
                      <td>{row.zip_code}</td> */}
                  <td>
                    <div className="actions">

                      <PermissionWrapper permissionKey="edit_permission" moduleId={ModuleId}>
                        <span
                          className="edit-icon"
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleEditClick(row.id)}
                        >
                          <img src={Vector} alt="Edit" width="20" height="20" />
                        </span>
                      </PermissionWrapper>

                      <PermissionWrapper permissionKey="delete_permission" moduleId={ModuleId}>
                        <span
                          className="delete-icon"
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleDeleteUser(row.id)}
                        >
                          <img src={Delete} alt="Delete" width="40" height="40" />
                        </span>
                      </PermissionWrapper>
                    </div>
                  </td>
                    </tr>
                  ))) : (
                <tr>
                  {searchTerm && tableData.length === 0 && (
                    <td colSpan="7" style={{ textAlign: 'center', padding: '20px', fontSize: '14px', color: '#666' }}>
                      No Users found matching "{searchTerm}"
                    </td>
                  )}
                </tr>
              )}
            </tbody>
          </table>
  
        </div>

        <div className="pagination-container d-flex align-items-center justify-content-between mt-3">

          {/* Limit Dropdown - Wrapped in d-flex to enable gap */}
          <div className="Limit-Dropdown">
            <label htmlFor="limit" className="fw-semibold">Items per page:</label>
            <select
              id="limit"
              value={limit}
              onChange={handleLimitChange}
              className="form-select d-inline w-auto"
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
            </select>
          </div>


          {/* Pagination Component - Wrapped in d-flex to enable gap */}
          <div className="d-flex align-items-center gap-4">
            <ReactPaginate
              previousLabel="Previous"
              nextLabel="Next"
              pageCount={totalPages}
              onPageChange={handlePageClick}
              forcePage={currentPage}
              containerClassName="pagination"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              activeClassName="active"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              marginPagesDisplayed={1}
              pageRangeDisplayed={3}
              disabledClassName="disabled"
            />

          </div>

        </div>
      </div>
      <CommonFooter />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
      <ConfirmDialog
        open={confirmOpen}
        title="Delete Confirmation"
        message="Are you sure you want to delete this User?"
        confirmText="Delete"
        cancelText="Cancel"
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
      />
    </>
  );
};

export default User;